import log from 'salvo-lite/log'
import axios from 'axios'
import Cart from './Cart'
import $ from 'jquery'
class ProductForm {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._formData = JSON.parse(elem.getAttribute('data-product-form'))
        this._swatchContainers = elem.querySelectorAll('.swatch-container')
        this._submitBtn = elem.querySelector('[data-submit]')
        this._currency = JSON.parse(elem.getAttribute('data-currency'))
        this._sideCartContainer = document.querySelector('.cart__items-container')
        this._idleTimer = null
        this._currentOptions = []
        this._selectedVariant = null
        this._cart = new Cart(theme, document.querySelector('.side-cart'))
        this._emptyCartTextSave = document.querySelector('.empty-cart-text')
        this._cartItems = document.querySelector('#cart-items')
        this._menuCartItems = document.querySelectorAll('.user-menu__bag__counter')
        this._collectionTitle = elem.getAttribute('data-collection-title')
        this._colorOptionIndex = parseInt(elem.getAttribute('data-color-option-index'))
        this._sizeOptionIndex = parseInt(elem.getAttribute('data-size-option-index'))
        this._product = JSON.parse(elem.getAttribute('data-product'))
        this._quickViewContainer = elem.closest('.collection__quick-view')

        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._submitBtn.addEventListener('click', () => this.handleSubmit())

        if (this._formData.variants.length === 1) {
            this._selectedVariant = this._formData.variants[0]
            return
        }

        this._swatchContainers.forEach(container => {
            const swatches = container.querySelectorAll('.swatch')

            swatches.forEach(swatch => {
                swatch.addEventListener('click', () => {
                    swatches.forEach(_swatch => {
                        _swatch.classList.remove('checked')
                    })

                    swatch.classList.add('checked')
                    this.changeVariant(swatch)
                })
            })
        })

        this.changeVariant()
    }

    changeVariant (selectedSwatch) {
        this._currentOptions = []

        this._swatchContainers.forEach(container => {
            const swatches = container.querySelectorAll('.swatch')

            swatches.forEach(swatch => {
                if (swatch.classList.contains('checked')) {
                    this._currentOptions.push(swatch.id)
                }
            })
        })

        const variants = this._formData.variants

        this._selectedVariant = variants.find(variant => {
            if (variant.options.sort().join('') === this._currentOptions.sort().join('')) {
                return variant
            }
        })

        if (selectedSwatch && selectedSwatch.classList.contains('color-swatch')) {
            this.updateSizeSwatches()
        }

        this.updateAddToCartButton(this._selectedVariant.id)

        // If in quick view popup, change the image
        if (this._quickViewContainer) {
            this.switchSlickProductImage(this._selectedVariant.id)
        }
    }

    switchSlickProductImage (variantId) {
        // Get the slick element
        const sliderElement = this._quickViewContainer.querySelector('[data-slick]')
        if (sliderElement) {
            const slider = $(sliderElement)
            // Match the clicked variant id with the corresponding image
            const slideForVariant = sliderElement.querySelector(`[data-variant-id="${variantId}"`)
            // Get the index from the parent slide and change
            if (slideForVariant) {
                const slideParent = slideForVariant.closest('.slick-slide')
                const slideIndex = slideParent.dataset.slickIndex
                slider.slick('slickGoTo', slideIndex)
            }
        }
    }

    updateSizeSwatches () {
        const swatchesArray = [...this._elem.querySelectorAll('.size-swatch')]

        for (let swatchElement of swatchesArray) {
            const swatchVariant = this._product.variants.find((variant) => {
                const colorMatches = variant.options[this._colorOptionIndex].toLowerCase() === this._selectedVariant.options[this._colorOptionIndex].toLowerCase()
                const sizeMatches = variant.options[this._sizeOptionIndex].toLowerCase() === swatchElement.id
                return colorMatches && sizeMatches
            })

            if (swatchVariant && swatchVariant.available) {
                swatchElement.classList.remove('swatch--oos')
            } else {
                swatchElement.classList.add('swatch--oos')
            }
        }
    }

    updateAddToCartButton (variantId) {
        const swatchVariant = this._product.variants.find((variant) => {
            return variant.id === variantId
        })

        if (swatchVariant && swatchVariant.available) {
            this._submitBtn.disabled = ''
        } else {
            this._submitBtn.disabled = 'disabled'
        }
    }

    async handleSubmit () {
        try {
            await axios.post('/cart/add.js', {
                items: [
                    {
                        id: this._selectedVariant.id,
                        quantity: 1,
                        properties: {
                            'collectionTitle': this._collectionTitle
                        }
                    }
                ]
            })

            const cartData = await axios.get('/cart.js')

            const dollarAmount = (cartData.data.total_price / 100).toLocaleString() + '.00'
            if (this._currency.position === 'front') {
                document.querySelector('#side-cart__subtotal').innerHTML = this._currency.symbol + dollarAmount
            } else {
                document.querySelector('#side-cart__subtotal').innerHTML = dollarAmount + this._currency.symbol
            }

            if (this._cartItems) {
                this._cartItems.innerHTML = cartData.data.item_count
            }

            if (this._menuCartItems.length > 0) {
                this._menuCartItems.forEach(element => {
                    element.innerHTML = cartData.data.item_count
                })
            }

            this._emptyCartTextSave.classList.remove('active')

            const items = cartData.data.items
            const currentItems = [...document.querySelectorAll('.cart__item-card')].map(item => parseInt(item.id))

            for (let i = 0; i < items.length; i++) {
                if (!currentItems.includes(items[i].id)) {
                    this.buildSingleCartItem(items[i], this._cart)
                } else {
                    const card = [...document.querySelectorAll('.cart__item-card')].filter(el => {
                        if (parseInt(el.id) === items[i].id) {
                            return el
                        }
                    })[0]

                    card.querySelector('.item-card__quantity [name="quantity"]').value = items[i].quantity
                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    async buildSideCart () {
        const cartJSON = await axios.get('/cart.js')
        const cartItems = cartJSON.data.items

        if (this._cartItems) {
            this._cartItems.innerHTML = cartJSON.data.item_count
        }

        if (this._menuCartItems.length > 0) {
            this._menuCartItems.forEach(element => {
                element.innerHTML = cartJSON.data.item_count
            })
        }

        if (cartItems.length === 0) {
            document.querySelector('.empty-cart-text').classList.add('active')
        } else {
            for (let i = 0; i < cartItems.length; i++) {
                this.buildSingleCartItem(cartItems[i], this._cart)
            }
        }
    }

    buildSingleCartItem (item, cart) {
        const html = document.createElement('div')

        html.id = item.id
        html.classList.add('cart__item-card', 'flex', 'f-space-between')

        const wrapper1 = document.createElement('div')
        wrapper1.classList.add('flex')

        html.appendChild(wrapper1)

        const imageContainer = document.createElement('div')
        imageContainer.classList.add('item-card__image', 'flex', 'f-center', 'f-vertical-center')

        const img = document.createElement('img')
        img.src = item.featured_image.url

        imageContainer.appendChild(img)
        wrapper1.appendChild(imageContainer)

        const itemInfo = document.createElement('div')
        itemInfo.classList.add('item-card__info', 'flex', 'f-dir-column')

        const collectionTitle = document.createElement('span')
        collectionTitle.classList.add('title', 'title--xxs', 'medium', 'collection-title')

        collectionTitle.innerHTML = item.properties.collectionTitle
        itemInfo.appendChild(collectionTitle)

        const itemTitle = document.createElement('span')
        itemTitle.classList.add('title', 'title--sm', 'medium', 'product-title')

        itemTitle.innerHTML = item.title.split(' -')[0]
        itemInfo.appendChild(itemTitle)

        wrapper1.appendChild(itemInfo)

        const options = item.options_with_values
        for (let i = 0; i < options.length; i++) {
            if (options[i].name !== 'Title') {
                const newOption = document.createElement('span')
                newOption.classList.add('title', 'title--xxxs', 'light', 'product-option')
                newOption.innerHTML = `${options[i].name}: ${options[i].value}`
                itemInfo.appendChild(newOption)
            }
        }

        const quantity = document.createElement('div')
        quantity.classList.add('item-card__quantity', 'flex')
        quantity.setAttribute('data-quantity-selector', item.id)

        const minus = document.createElement('input')
        minus.setAttribute('type', 'button')
        minus.setAttribute('value', '-')
        minus.setAttribute('data-minus', '')

        quantity.appendChild(minus)

        const qtyIncrement = document.createElement('input')
        qtyIncrement.setAttribute('type', 'number')
        qtyIncrement.setAttribute('step', '1')
        qtyIncrement.setAttribute('max', '')
        qtyIncrement.setAttribute('value', item.quantity)
        qtyIncrement.setAttribute('name', 'quantity')

        quantity.appendChild(qtyIncrement)

        const plus = document.createElement('input')
        plus.setAttribute('type', 'button')
        plus.setAttribute('value', '+')
        plus.setAttribute('data-plus', '')

        quantity.appendChild(plus)

        itemInfo.appendChild(quantity)

        quantity.querySelector('[data-minus]').addEventListener('click', () => {
            if (parseInt(qtyIncrement.value) - 1 === 0) {
                const removeItem = quantity.closest('.cart__item-card')
                setTimeout(() => removeItem.parentElement.removeChild(removeItem), 500)
            }

            qtyIncrement.value = parseInt(qtyIncrement.value) - 1
            cart.delayUpdate(item.id, qtyIncrement.value)
        })

        quantity.querySelector('[data-plus]').addEventListener('click', () => {
            qtyIncrement.value = parseInt(qtyIncrement.value) + 1
            cart.delayUpdate(item.id, qtyIncrement.value)
        })

        const rightSide = document.createElement('div')
        rightSide.classList.add('flex', 'f-dir-column', 'f-space-between', 'f-vertical-bottom')

        const currency = document.createElement('span')
        currency.classList.add('title', 'title--xxs', 'light', 'product-price')

        const dollarAmount = (item.price / 100).toLocaleString()
        if (this._currency.position === 'front') {
            currency.innerHTML = this._currency.symbol + dollarAmount
        } else {
            currency.innerHTML = dollarAmount + this._currency.symbol
        }

        rightSide.appendChild(currency)

        const remove = document.createElement('span')
        remove.classList.add('title', 'title--xxxs', 'medium', 'underline', 'remove-item')
        remove.setAttribute('data-remove-item', item.id)
        remove.innerHTML = 'Remove'

        remove.addEventListener('click', () => {
            this._cart.updateCart(item.id, 0, true)
        })

        rightSide.appendChild(remove)

        html.appendChild(rightSide)

        this._sideCartContainer.appendChild(html)
    }
}

export default ProductForm



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductForm.js